import React, { useEffect, useState } from "react";

// Fix for accessibility issues. Issue # VII26-08
import { getAllSchemeOverviewData, getSchemeOverviewDataByFilter } from "../../utils/util";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import moment from "moment";
import { IndianRupee } from "lucide-react";
import { truncateToDecimalPlaces } from "../../utils/helper";

const Overview = ({ selectedSchemeOptions = [], footer = true, }) => {
  const [schemeOverviewData, setSchemeOverviewData] = useState()
  const [aumDataForSpecificScheme, setAumDataForSpecificScheme] = useState(0)
  const [investorSchemeDetails, setInvestorSchemeDetails] = useState()
  const dispatch = useDispatch()
  // const handleGetAllSchemeOverviewData=async()=>{
  //   dispatch(loaderSet(true))
  //   try {
  //     const response=await getAllSchemeOverviewData()
  //     console.log("Response for handleGetAllSchemeOverviewData function",response)
  //     dispatch(loaderSet(false))
  //   } catch (error) {
  //     console.log("Errorn in handleGetAllSchemeOverviewData function",error)
  //     dispatch(loaderSet(false))
  //   }
  // }

  // const handleGetSchemeOverviewDataByFilter=async()=>{
  //   dispatch(loaderSet(true))
  //   const payload={
  //     scheme_name: selectedSchemeOptions && selectedSchemeOptions.length>0 ? selectedSchemeOptions[0]?.split("-")[0] : "Vasuki India Fund",
  //     scheme_class: selectedSchemeOptions && selectedSchemeOptions.length>0 ? selectedSchemeOptions[0].split("-")[1] : "A"
  //   }
  //   try {
  //     const response=await getSchemeOverviewDataByFilter(payload)
  //     console.log("Response for handleGetSchemeOverviewDataByFilter ",response)
  //     if(response){
  //       setSchemeOverviewData(response.data[0])
  //     }
  //     dispatch(loaderSet(false))
  //   } catch (error) {
  //     console.log("Error in handleGetSchemeOverviewDataByFilter function",error)
  //     dispatch(loaderSet(false))
  //   }

  // }

  // useEffect(()=>{
  //   handleGetSchemeOverviewDataByFilter()
  //   handleGetAllSchemeOverviewData()
  // },[selectedSchemeOptions])

  const allSchemeDetails = useSelector(state => state.schemeInfoAgainstInvestor);
  const aumDataAgainstScheme = useSelector(state => state.aumDataAgainstScheme)
  const investorInfo = useSelector((state) => state.investorInfo)
  useEffect(() => {
    if (selectedSchemeOptions && selectedSchemeOptions.length > 0 && allSchemeDetails && allSchemeDetails.length > 0) {
      const schemeName = selectedSchemeOptions[0]?.split("-")[0];
      const schemeClass = selectedSchemeOptions[0]?.split("-")[1];

      const innerBlockSchemeOverviewData = allSchemeDetails.filter((overviewData) => (
        overviewData.scheme_name === schemeName && overviewData.scheme_class === schemeClass
      ));

      setSchemeOverviewData(innerBlockSchemeOverviewData[0])

      // You can now use innerBlockSchemeOverviewData for further actions
      console.log("setSchemeOverviewData(innerBlockSchemeOverviewData)", innerBlockSchemeOverviewData);
      console.log("AUM DATA", aumDataAgainstScheme)
      if (Array.isArray(aumDataAgainstScheme) && aumDataAgainstScheme.length > 0) {
        const innerBlovkForAumDataForSpecificScheme = aumDataAgainstScheme.filter(
          (aum) => aum.scheme_name === schemeName && aum.scheme_class === schemeClass
        );

        // Check if the filtered data exists and has a non-empty `schemes` property
        if (
          innerBlovkForAumDataForSpecificScheme.length > 0 &&
          innerBlovkForAumDataForSpecificScheme[0]?.schemes &&
          innerBlovkForAumDataForSpecificScheme[0]?.schemes.length > 0
        ) {
          setAumDataForSpecificScheme(innerBlovkForAumDataForSpecificScheme[0].schemes[0]);

          console.log(
            "setAumDataForSpecificScheme(innerBlovkForAumDataForSpecificScheme)",
            innerBlovkForAumDataForSpecificScheme[0].schemes[0].aum
          );
        }
      }

      if (investorInfo && Array?.isArray(investorInfo?.schemes) && investorInfo?.schemes?.length > 0) {
        const innerBlockForInvestorScheme = investorInfo?.schemes?.filter(scheme =>
          scheme?.scheme_name === schemeName && scheme?.scheme_class === schemeClass
        )
        setInvestorSchemeDetails(innerBlockForInvestorScheme[0])
        console.log("setInvestorSchemeDetails(innerBlockForInvestorScheme)", innerBlockForInvestorScheme)
      }

    }

  }, [selectedSchemeOptions, allSchemeDetails, aumDataAgainstScheme, investorInfo]);




  // function formatDate(dateString, fallback = 0) {
  //   if (!dateString) return fallback;

  //   // Try parsing ISO format or other recognized formats
  //   let parsedDate = moment(dateString, moment.ISO_8601, true);

  //   if (!parsedDate.isValid()) {
  //     // Fallback to parsing "DD.MM.YYYY" format
  //     parsedDate = moment(dateString, "DD.MM.YYYY", true);
  //   }

  //   if (!parsedDate.isValid()) {
  //     // Fallback to JavaScript Date object for formats like "Tue Jan 14 2025..."
  //     const jsDate = new Date(dateString);
  //     if (!isNaN(jsDate.getTime())) {
  //       parsedDate = moment(jsDate);
  //     }
  //   }

  //   // Return formatted date or fallback if still invalid
  //   return parsedDate.isValid() ? parsedDate.format("DD-MM-YYYY") : fallback;
  // }


  function formatDate(dateString, fallback = 0) {
    if (!dateString) return fallback;

    // Try parsing ISO format or other recognized formats
    let parsedDate = moment(dateString, moment.ISO_8601, true);

    if (!parsedDate.isValid()) {
      // Fallback to parsing "DD.MM.YYYY" format
      parsedDate = moment(dateString, "DD.MM.YYYY", true);
    }
    if (!parsedDate.isValid()) {
      // Fallback to parsing "DD.MM.YYYY" format
      parsedDate = moment(dateString, "DD-MM-YYYY", true);
    }
    if (!parsedDate.isValid()) {
      // Fallback to parsing "DD MMM YYYY" format (e.g., "01 Jan 2020")
      parsedDate = moment(dateString, "DD MMM YYYY", true);
    }

    if (!parsedDate.isValid()) {
      // Handle cases like "Thu Nov 07 2024 00:00:00 GMT+0530"
      const jsDate = new Date(dateString);
      if (!isNaN(jsDate.getTime())) {
        parsedDate = moment(jsDate);
      }
    }

    // Return formatted date in "DD MMM YYYY" format or fallback if invalid
    return parsedDate.isValid() ? parsedDate.format("DD MMM YYYY") : fallback;
  }

  return (
    <>
      <div>
        <div className=" mb-12">

          <h2 className="text-2xl mt-6 font-bold bg-[#0E2841] text-white py-3 pl-2 rounded-sm mb-2">Overview</h2>
          <h3 className="font-bold text-xl py-2">
            {schemeOverviewData?.scheme_name || "Scheme Overview"}
            {schemeOverviewData?.scheme_class ? ` - Class (${schemeOverviewData.scheme_class})` : ""}
          </h3>
          <p className="text-md  font-semibold text-gray-500">
            {schemeOverviewData?.scheme_description || "This is a Close Ended CAT-III Alternate Investment Fund."}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">
                Scheme Tenure
              </dt>
              <dd className="font-bold text-2xl text-slate-950">{schemeOverviewData?.fund_tenure || 0}</dd>
            </dl>
          </div>
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">
                Launch Date
              </dt>
              <dd className="font-bold text-2xl text-slate-950">{!schemeOverviewData?.launch_date ? "N/A" : formatDate(schemeOverviewData?.launch_date) || 0}</dd>
            </dl>
          </div>

          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">NAV / Per Unit</dt>
              <dd className="font-bold text-2xl mb-3 flex items-center text-slate-950">
                <IndianRupee className="font-bold" aria-hidden="true" /><span className="sr-only">Indian Rupee</span> {schemeOverviewData?.nav || 0}
              </dd>
              <dd className="text-slate-700 font-semibold text-xl">
                As of {formatDate(schemeOverviewData?.as_on_date)}
              </dd>
            </dl>
          </div>
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col ">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">AUM</dt>
              <dd className="font-bold text-2xl mb-3 flex items-center text-slate-950">
                <IndianRupee className="font-bold" aria-hidden="true" /><span className="sr-only">Indian Rupee</span> {aumDataForSpecificScheme?.aum ? Number((aumDataForSpecificScheme?.aum)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}
              </dd>
              <dd className="text-slate-700 font-semibold text-xl">
                As of {formatDate(schemeOverviewData?.as_on_date)}
              </dd>
            </dl>
          </div>
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">
                Benchmark
              </dt>
              <dd className="font-bold text-2xl text-slate-950">{schemeOverviewData?.benchmark || 0}</dd>
            </dl>
          </div>
        </div>
        <div className=" mb-12">
          <h2 id="portfolio-heading" className="text-2xl mt-6 font-bold bg-[#0E2841] text-white py-3 pl-2 rounded-sm mb-2">My portfolio</h2>

        </div>
        <section aria-labelledby="portfolio-heading" className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">
                Contribution Amount
              </dt>
              <dd className="font-bold text-2xl flex items-center text-slate-950">
                <IndianRupee className="font-bold" aria-hidden="true" />
                <span className="sr-only">Indian Rupee</span>
                {Number(investorSchemeDetails?.contribution).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0.00}
              </dd>
            </dl>
          </div>
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">
                Purchase Price
              </dt>
              <dd className="font-bold text-2xl flex items-center text-slate-950">
                <IndianRupee className="font-bold" aria-hidden="true" /><span className="sr-only">Indian Rupee</span> {investorSchemeDetails?.purchase_value ? truncateToDecimalPlaces(investorSchemeDetails?.purchase_value, 2) : 0.00}
              </dd>
            </dl>
          </div>
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">
                No. of Units Issued
              </dt>
              <dd className="font-bold text-2xl text-slate-950" aria-label={`Number of units issued ${investorSchemeDetails?.number_of_units ? Number(investorSchemeDetails?.number_of_units).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`}>{investorSchemeDetails?.number_of_units ? Number(investorSchemeDetails?.number_of_units).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0.00}</dd>
            </dl>
          </div>
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">Current Investment Value</dt>
              <dd className="font-bold text-2xl flex items-center mb-3 text-slate-950">
                <IndianRupee className="font-bold" aria-hidden="true" /><span className="sr-only">Indian Rupee</span> {investorSchemeDetails?.valuation ? Number(investorSchemeDetails?.valuation).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0.00}
              </dd>
              <dd className="text-slate-700 font-semibold text-xl ">As of {formatDate(schemeOverviewData?.as_on_date)}</dd>
            </dl>
          </div>
          <div className="flex mb-4 gap-4 justify-between">
            <dl className="bg-gray-100 w-full h-full p-4 rounded-lg shadow-md flex flex-col">
              <dt className="text-slate-700 font-semibold text-xl mb-3 leading-snug">
                Date of Allotement of Units
              </dt>
              <dd className="font-bold text-2xl text-slate-950">{investorSchemeDetails?.date_of_allotement_units ? formatDate(investorSchemeDetails?.date_of_allotement_units) : "N/A"}</dd>
            </dl>
          </div>
        </section>
        {footer && <p className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2">Note: Please reach out to us at <a href="mailto:vasuki.compliance@vasukiindia.com" className="text-blue-700 underline font-normal" aria-label="Email Vasuki Compliance">vasuki.compliance@vasukiindia.com</a> for more details
        </p>}
        <p className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2" ></p>



      </div>
    </>
  );
};

export default Overview;
